import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { LocationIcon, Tooltip, InfoIcon } from 'components';

import './address.scss';

export const Address = (props) => {
  const { address, className, isContact, tooltipInfo, tooltipWidth } = props;

  return (
    <div
      className={cns(`address montserrat word-break ${className}`, {
        'address-contact': isContact,
        'address-with-tooltip': tooltipInfo,
      })}
    >
      <span>
        <LocationIcon />
      </span>
      <span className="ml-2">{address}</span>
      {tooltipInfo && (
        <div className="form-fields__tooltip">
          <Tooltip width={tooltipWidth} info={tooltipInfo}>
            <InfoIcon width="17px" height="17px" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

Address.propTypes = {
  isContact: PropTypes.bool,
  address: PropTypes.string,
  className: PropTypes.string,
};

Address.defaultProps = {
  address: '',
  className: '',
};
